import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getInstitutionsList} from '../../actions';
import InstitutionsListItem from './InstitutionsListItem';
import InstitutionsListItemPlaceholder from './InstitutionsListItemPlaceholder';
import LoadingSpinner from '../../../Layout/components/LoadingSpinner';
import Button from '@material-ui/core/Button';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_institutions_list.json';
import Waypoint from 'react-waypoint';

const NUMBER_ITEMS_PER_LINE = 4;
const NUMBER_ITEMS_PLACEHOLDER_INITIAL_LOADING = 8;

class InstitutionsList extends Component {
    state = {
        initialLoad: true,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    fetchContent() {
        const {loading} = this.props;

        if (!loading) {
            this.props.getInstitutionsList(
                1, // No offset
                true, // Reset the search results / listing
            );
        }
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.languages !== this.props.languages) {
            const {pathname} = this.props.location;
            const expectedUri = this.props.translate('routes.institutions');

            if (pathname !== expectedUri) {
                this.props.history.push(expectedUri);
            } else {
                this.fetchContent();
            }
        }
    }

    handleScrollLoadMore = () => {
        this.loadMore();
    };

    handleClickLoadMore = (e) => {
        e.preventDefault();

        this.loadMore();
    };

    loadMore = (e) => {
        const {loading, hasMore, currentPage} = this.props;

        if (hasMore && !loading) {
            this.setState({initialLoad: false});

            this.props.getInstitutionsList(currentPage + 1);
        }
    };

    render() {
        const {items, loading, hasMore} = this.props;

        let placeholders = [];
        let placeholders2 = [];

        if (this.state.initialLoad) {
            for (let i = 0; i < NUMBER_ITEMS_PLACEHOLDER_INITIAL_LOADING; i++) {
                placeholders.push(<InstitutionsListItemPlaceholder key={i}/>);
            }
        } else {
            for (let i = 0; i < NUMBER_ITEMS_PER_LINE; i++) {
                placeholders2.push(<InstitutionsListItemPlaceholder key={i}/>);
            }
        }

        return (
            <section id="institutions-list">
                <div className="row">
                    {(this.state.initialLoad && loading && Array.isArray(items) && items.length === 0) && placeholders}
                    {items.map(institutions => (
                        <InstitutionsListItem key={institutions.id} institutions={institutions}/>
                    ))}
                    {(loading && !this.state.initialLoad) && placeholders2}
                    {(!loading && items.length === 0) &&
                        <div className="col col-12 text-center">
                            <p><Translate id="institutions_list.no_item_found" /></p>
                        </div>
                    }
                </div>
                {(hasMore && !loading) &&
                    <div className="row row-more">
                        <div className="col-lg-3 col-md-6 col-sm-12 mx-auto">
                            <div className="text-center">
                                <Waypoint onEnter={this.handleScrollLoadMore} />
                                <Button variant="contained" color="primary" size="medium" onClick={this.handleClickLoadMore} className="btn-more">
                                    <Translate id="institutions_list.button_load_more" />
                                </Button>
                            </div>
                        </div>
                    </div>
                }
                {((Array.isArray(items) && items.length === 0 || loading) && !this.state.initialLoad) &&
                    <div className="row row-loading">
                        <div className="col-lg-3 col-md-6 col-sm-12 mx-auto">
                            <div className="text-center">
                                <LoadingSpinner/>
                            </div>
                        </div>
                    </div>
                }
            </section>
        );
    }
}

InstitutionsList.propTypes = {
    getInstitutionsList: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    loading: state.institutions.institutionsListLoading,
    hasMore: state.institutions.hasMore,
    currentPage: state.institutions.currentPage,
    items: state.institutions.institutionsList,
});

export default withRouter(connect(mapStateToProps, {getInstitutionsList})(withLocalize(InstitutionsList)));



// WEBPACK FOOTER //
// ./src/features/Institutions/components/List/InstitutionsList.js